import { 
    getCountries,
    getVendors,
    getAccountNumbers,
    getInvoiceStatus,
 } from "../../../../constants/model-reducers/external/invoice/account-payable/account-payable.setting";
import { httpGet } from "../../../../utils/api.utils";

const defaultState=()=>({
    countries:[],
    totalCount:0,
    vendors:[],
    vendorTotalCount:0,
    accountNumbers:[],
    accountNumbersTotalCount:0,
    invoiceStatus:[],
    invoiceStatusTotalCount:0
});

const initialState = defaultState();

export const AccountPayableActions = {
    fetchListCountries:(offSet=0, searchString="")=>async (dispatch, state)=>{
        const limit = 15;
        try {
            const params = new URLSearchParams({
                offSet: offSet,
                limit: limit,
            });

            if (searchString) {
                params.append('searchString', searchString);
            }

            if (!searchString) params.delete('searchString');

            var res = await httpGet(`external/referencedata/getAllContiresAsync?${params.toString()}`);
            if(res) {
                dispatch({
                    type: getCountries,
                    countries: res.items,
                    totalItems: res.totalCount,
                    offSet: offSet
                });
                return res;
            }

        }catch(apiError) {
           console.log(apiError);
        }
    },
    fetchListVendors:(offSet=0, searchString="", countrySelection=null)=> async (dispatch,state)=>{
         const limit = 15;
        try {
            const params = new URLSearchParams({
                offSet: offSet,
                limit: limit,
            });

            if (searchString) {
                params.append('searchString', searchString);
            }

            if (countrySelection) {
                if (countrySelection.selectAllFilters && countrySelection.selectAllFilters.length > 0) {                    
                    params.append('countryNameFilter', countrySelection.selectAllFilters.join(','));
                } 
                
                if (countrySelection.selectedKeys && countrySelection.selectedKeys.length > 0) {
                    params.append('countryIds', countrySelection.selectedKeys.join(','));
                }

                if (countrySelection.excludedKeys && countrySelection.excludedKeys.length > 0) {
                    params.append('excludedCountryIds', countrySelection.excludedKeys.join(','));
                }
            }

            var res = await httpGet(`external/referencedata/getVendorByCountryAsync?${params.toString()}`);
            if(res) {
                dispatch({
                    type: getVendors,
                    vendorList: res.items,
                    totalItems: res.totalCount,
                    offSet: offSet
                });
                return res;
            }

        }catch(apiError) {
           console.log(apiError);
        }
    },
    fetchListAccountNumber:(offSet=0, searchString="", vendorSelection=null)=>async (dispatch, state)=>{
         const limit = 15;
        try {
            const params = new URLSearchParams({
                offSet: offSet,
                limit: limit,
            });

            if (searchString) {
                params.append('searchString', searchString);
            }

            if (vendorSelection) {
                if (vendorSelection.selectAllFilters && vendorSelection.selectAllFilters.length > 0) {                    
                    params.append('vendorNameFilters', vendorSelection.selectAllFilters.join(','));
                } 
                
                if (vendorSelection.selectedKeys && vendorSelection.selectedKeys.length > 0) {
                    params.append('vendorIds', vendorSelection.selectedKeys.join(','));
                }

                if (vendorSelection.excludedKeys && vendorSelection.excludedKeys.length > 0) {
                    params.append('excludedVendorIds', vendorSelection.excludedKeys.join(','));
                }
            }

            var res = await httpGet(`external/referencedata/getAccountNumberByVendorsAsync?${params.toString()}`);
            if(res) {
                dispatch({
                    type: getAccountNumbers,
                    accountNumbersList: res.items,
                    totalItems: res.totalCount,
                    offSet: offSet
                });
                return res;
            }

        }catch(apiError) {
           console.log(apiError);
        }
    },
    fetchInvoiceStatus:(offSet=0, searchString="")=>async (dispatch, state)=>{
         const limit = 15;
        try {
            const params = new URLSearchParams({
                offSet: offSet,
                limit: limit,
            });

            if (searchString) {
                params.append('searchString', searchString);
            }

            var res = await httpGet(`external/referencedata/getInvoiceStatusAsync?${params.toString()}`);
            if(res) {
                dispatch({
                    type: getInvoiceStatus,
                    invoiceStatusList: res.items,
                    totalItems: res.totalCount,
                    offSet: offSet
                });
                return res;
            }

        }catch(apiError) {
           console.log(apiError);
        }
    }
}

export const reducer = (state = initialState, action) => {
    switch(action.type) {
        case getCountries: {
            const items = action.offSet === 0
                ? action.countries
                : [...state.countries, ...action.countries];

            return {
                ...state,
                countries: items,
                totalCount: action.totalItems
               
            };
        }
        case getVendors: {
            const items = action.offSet === 0
                ? action.vendorList
                : [...state.vendors, ...action.vendorList];
            return {
                ...state,
                vendors: items,
                vendorTotalCount: action.totalItems
            }
        }
        case getAccountNumbers: {
            const items = action.offSet === 0
                ? action.accountNumbersList
                : [...state.accountNumbers, ...action.accountNumbersList];
            return {
                ...state,
                accountNumbers: items,
                accountNumbersTotalCount: action.totalItems
            }
        }
        case getInvoiceStatus: {
             const items = action.offSet === 0
                ? action.invoiceStatusList
                : [...state.invoiceStatus, ...action.invoiceStatusList];
                 return {
                    ...state,
                    invoiceStatus: items,
                    invoiceStatusTotalCount: action.totalItems
                }
        }
        default:
            return state;
    }    
};